import * as yup from 'yup';
export const initialValues = {
	fullname: '',
	contactname: '',
	position: '',
	cnpj: '',
	numEmployees: '',
	plan: '',
	email: '',
	phone: [''],
	privacy: false,
};

export function checkCNPJ(cnpjArg) {
	if (cnpjArg == null || cnpjArg == '') {
		return false;
	}
	let cnpj = cnpjArg.replace(/[^\d]+/g, '');

	if (cnpj == '') {
		return false;
	}

	if (cnpj.length != 14) {
		return false;
	}

	// Elimina CNPJs invalidos conhecidos
	if (
		cnpj == '00000000000000' ||
		cnpj == '11111111111111' ||
		cnpj == '22222222222222' ||
		cnpj == '33333333333333' ||
		cnpj == '44444444444444' ||
		cnpj == '55555555555555' ||
		cnpj == '66666666666666' ||
		cnpj == '77777777777777' ||
		cnpj == '88888888888888' ||
		cnpj == '99999999999999'
	) {
		return false;
	}
	// Valida DVs
	let tamanho = cnpj.length - 2;
	let numeros = cnpj.substring(0, tamanho);
	let digitos = cnpj.substring(tamanho);
	let resultado;
	let soma = 0;
	let pos = tamanho - 7;
	for (let i = tamanho; i >= 1; i--) {
		soma += numeros.charAt(tamanho - i) * pos--;
		if (pos < 2) {
			pos = 9;
		}
	}
	resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
	if (resultado != digitos.charAt(0)) {
		return false;
	}
	tamanho = tamanho + 1;
	numeros = cnpj.substring(0, tamanho);
	soma = 0;
	pos = tamanho - 7;
	for (let i = tamanho; i >= 1; i--) {
		soma += numeros.charAt(tamanho - i) * pos--;
		if (pos < 2) {
			pos = 9;
		}
	}
	resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
	if (resultado != digitos.charAt(1)) {
		return false;
	}

	return true;
}

const schema = yup.object().shape({
	fullname: yup.string().required('Nome da Empresa é obrigatório!'),
	contactname: yup.string().required('Nome do Contato é obrigatório!'),
	position: yup.string().required('Nome do Cargo é obrigatório!'),
	cnpj: yup
		.string()
		.matches(/([0-9]{2}.[0-9]{3}.[0-9]{3}\/[0-9]{4}.[0-9]{2})/, { message: 'CNPJ é obrigatório!', excludeEmptyString: true })
		.required('CNPJ é obrigatório!')
		.test('cnpj', 'CNPJ inválido!', checkCNPJ),
	email: yup.string().email('Email deve ter um formato válido!').required('Email é obrigatório!'),
	phone: yup
		.array()
		.min(1, 'Telefone é obrigatório!')
		.of(
			yup
				.string()
				.notRequired()
				.matches(/([0-9]{4,5}-[0-9]{4})/, { message: 'Telefone inválido!', excludeEmptyString: true }),
		)
		.test('testEmpty', 'Telefone é obrigatório!', val => {
			let hasOneValid = false;
			if (val.length > 0) {
				val.forEach(phone => {
					if (phone != null && !['', '(__) ____-____', '(__) _____-____'].includes(phone)) {
						hasOneValid = true;
					}
				});
			}
			return hasOneValid;
		}),
	numEmployees: yup.string().required('Quantidade de funcionários é obrigatório!'),
	plan: yup.string().required('Plano é obrigatório!'),
	privacy: yup.boolean().isTrue('Você precisa concordar com a política de privacidade!'),
});

export default schema;
